import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["modal_visible", "application_is_processing", "handleCloseModal"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/prop-types */
import React from 'react';
import Modal from 'react-modal';
import MultipleNotesView from "./MultipleNotesView";
import LoadingOverlay from "../../core/ui/LoadingOverlay";
var modal_styles = {
  overlay: {
    zIndex: 5000,
    backgroundColor: 'rgba(24, 39, 56, 0.85)'
  },
  content: {
    bottom: 'auto',
    height: '80vh',
    left: '50%',
    marginRight: '-50%',
    padding: '0px',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%'
  }
};
var MultipleNotes = function MultipleNotes(_ref) {
  var modal_visible = _ref.modal_visible,
    application_is_processing = _ref.application_is_processing,
    handleCloseModal = _ref.handleCloseModal,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: modal_visible,
    onRequestClose: handleCloseModal,
    style: modal_styles,
    ariaHideApp: false,
    contentLabel: "Multiple Notes Modal"
  }, application_is_processing && /*#__PURE__*/React.createElement(LoadingOverlay, null), modal_visible && /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%',
      position: 'relative',
      overflowY: 'auto',
      padding: '40px'
    }
  }, /*#__PURE__*/React.createElement(MultipleNotesView, _extends({
    applicationIsProcessing: application_is_processing
  }, props))));
};
export default MultipleNotes;